<template>
  <v-container class="not-found-page py-6" fluid>
    <v-row justify="center">
      <v-col cols="12" sm="10" md="8" lg="6">
        <v-card class="not-found-card" elevation="2">
          <v-card-text class="not-found-content">
            <div class="not-found-icon">
              <v-icon color="primary" size="52">
                mdi-map-marker-question-outline
              </v-icon>
            </div>

            <div class="error-code">
              404
            </div>

            <h1 class="not-found-title">
              Seite nicht gefunden
            </h1>

            <p class="not-found-description">
              Die angeforderte Seite existiert nicht, wurde verschoben
              oder ist nicht mehr verfügbar.
            </p>

            <div class="requested-path">
              <v-icon size="18" color="primary">
                mdi-link-variant
              </v-icon>

              <code>{{ route.fullPath }}</code>
            </div>

            <div class="not-found-actions">
              <v-btn
                color="primary"
                variant="elevated"
                :to="{ name: 'Home' }"
              >
                <v-icon start>mdi-home-outline</v-icon>
                Zur Startseite
              </v-btn>

              <v-btn
                variant="text"
                @click="goBack"
              >
                <v-icon start>mdi-arrow-left</v-icon>
                Zurück
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts" setup>
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()

function goBack() {
  if (window.history.length > 1) {
    router.back()
  } else {
    router.push({ name: 'Home' })
  }
}
</script>

<style scoped lang="scss">
.not-found-page {
  display: flex;
  align-items: center;
  min-height: calc(100vh - 180px);
}

.not-found-card {
  overflow: hidden;

  border: 1px solid rgba(var(--v-theme-on-surface), 0.08);
  border-radius: 28px;

  color: rgb(var(--v-theme-on-surface));
  background:
    linear-gradient(
      180deg,
      rgba(var(--v-theme-primary), 0.055),
      rgba(var(--v-theme-primary), 0.015)
    ),
    rgb(var(--v-theme-surface));
}

.not-found-content {
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 3rem 2rem;
  text-align: center;
}

/* Icon */
.not-found-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 92px;
  height: 92px;
  margin-bottom: 1.25rem;

  border: 1px solid rgba(var(--v-theme-primary), 0.12);
  border-radius: 999px;

  background-color: rgba(var(--v-theme-primary), 0.08);
}

/* Error text */
.error-code {
  color: rgb(var(--v-theme-primary));

  font-size: clamp(3rem, 8vw, 5.5rem);
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.04em;
}

.not-found-title {
  margin: 0.75rem 0 0;

  color: rgb(var(--v-theme-on-surface));

  font-size: clamp(1.5rem, 4vw, 2rem);
  font-weight: 700;
  line-height: 1.25;
}

.not-found-description {
  max-width: 460px;
  margin: 0.75rem 0 0;

  color: rgba(var(--v-theme-on-surface), 0.68);

  font-size: 0.95rem;
  line-height: 1.6;
}

/* Requested route */
.requested-path {
  display: flex;
  align-items: center;
  gap: 0.5rem;

  max-width: 100%;
  margin-top: 1.5rem;
  padding: 0.65rem 0.9rem;

  border: 1px solid rgba(var(--v-theme-on-surface), 0.08);
  border-radius: 14px;

  color: rgb(var(--v-theme-on-surface));
  background-color: rgba(var(--v-theme-on-surface), 0.045);
}

.requested-path code {
  overflow: hidden;

  font-family:
    ui-monospace,
    SFMono-Regular,
    Menlo,
    Monaco,
    Consolas,
    monospace;

  font-size: 0.82rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Actions */
.not-found-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  flex-wrap: wrap;

  margin-top: 1.75rem;
}

.not-found-actions .v-btn {
  font-weight: 600;
  text-transform: none;
}

/* Responsive */
@media (max-width: 600px) {
  .not-found-page {
    min-height: calc(100vh - 150px);
    padding-inline: 0.5rem;
  }

  .not-found-content {
    padding: 2rem 1rem;
  }

  .not-found-icon {
    width: 76px;
    height: 76px;
  }

  .requested-path {
    width: 100%;
  }

  .not-found-actions {
    align-items: stretch;
    flex-direction: column;

    width: 100%;
  }

  .not-found-actions .v-btn {
    width: 100%;
  }
}
</style>